import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-change-account-password',
  templateUrl: './change-account-password.component.html',
  styleUrls: ['./change-account-password.component.scss'],
})
export class ChangeAccountPasswordComponent implements OnInit {
  inputForm: FormGroup;
  componentReady = false;

  constructor() {
  }

  get password(): AbstractControl {
    return this.inputForm.get('password');
  }

  get password_confirmation(): AbstractControl {
    return this.inputForm.get('password_confirmation');
  }

  ngOnInit(): void {
    this.inputForm.addControl(
      'password',
      new FormControl('', [
        Validators.required,
        Validators.minLength(8),
        Validators.pattern('^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\\W).{8,}$'),
      ]),
    );
    // create a validator for the password confirmation field that compares the value of the password field
    this.inputForm.addControl(
      'password_confirmation',
      new FormControl('', [
        Validators.required,
        Validators.minLength(8),
        (control: FormControl) => {
          if (control.value !== this.inputForm.get('password').value) {
            return { passwordsDontMatch: true };
          }
          return null;
        },
      ]),
    );
    this.componentReady = true;
  }

  hasControlErrors(control: AbstractControl) {
    return control.invalid && (control.dirty || control.touched);
  }
}
